import entities.Ad
import entities.Category
import entities.OrgProduct
import entities.PlacementCat
import models.CategoryModel
import models.OrganizationModel
import models.ProductModel

fun adToJsonString(ad: Ad): String {
    return buildString {
        append("{")
        append("\"id\": ${ad.id}, ")
        append("\"name\": \"${ad.name}\", ")
        append("\"message\": \"${ad.message}\"")
        append("}")
    }
}

fun organisationModelToJsonString(organizationModel: OrganizationModel): String {
    return buildString {
        append("{")
        append("\"id\": ${organizationModel.id}, ")
        append("\"name\": \"${organizationModel.name}\", ")
        append("\"sait\": \"${organizationModel.sait}\", ")
        append("\"note\": \"${organizationModel.note}\", ")
        append("\"userName\": \"${organizationModel.userName}\", ")
        append("\"isactive\": ${organizationModel.isactive}")
        append("}")
    }
}

fun categoryToJsonString(category: Category): String {
    return buildString {
        append("{")
        append("\"id\": ${category.id}, ")
        append("\"name\": \"${category.name}\", ")
        append("\"parent_id\": ${category.parent_id}, ")
        append("\"iscategory\": ${category.iscategory}, ")
        append("\"isactive\": ${category.isactive}")
        append("}")
    }
}

fun productModelToJsonString(productModel: ProductModel): String {
    return buildString {
        append("{")
        append("\"id\": ${productModel.id}, ")
        append("\"name\": \"${productModel.name}\", ")
        append("\"category\": \"${productModel.category}\"")
        append("}")
    }
}

fun orgProductToJsonString(orgProduct: OrgProduct): String {
    return buildString {
        append("{")
        append("\"id\": ${orgProduct.id}, ")
        append("\"org_id\": ${orgProduct.org_id}, ")
        append("\"prod_id\": ${orgProduct.prod_id}, ")
        append("\"fo\": \"${orgProduct.fo}\", ")
        append("\"note\": \"${orgProduct.note}\"")
        append("}")
    }
}

fun categoryModelToJsonString(category: CategoryModel): String {
    return buildString {
        append("{")
        append("\"id\": ${category.id}, ")
        append("\"name\": \"${category.name}\", ")
        append("\"parent\": \"${category.parent}\", ")
        append("\"iscategory\": ${category.iscategory}, ")
        append("\"isactive\": ${category.isactive}")
        append("}")
    }
}

fun placementCatToJsonString(placementCat: PlacementCat): String {
    return buildString {
        append("{")
        append("\"id\": ${placementCat.id}, ")
        append("\"category_id\": ${placementCat.category_id}, ")
        append("\"ad_id\": ${placementCat.ad_id}")
        append("}")
    }
}